/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ErrorPrompt.css";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

class ErrorPrompt extends Component {
  render() {
    const languageObj = this.props.t("ErrorPrompt".toUpperCase(), {
      returnObjects: true,
    });
    return (
      <div className="ErrorPrompt-view">
        <div className="ErrorPrompt-prompt">
          <div className="ErrorPrompt-errorIcn"></div>
          <div className="ErrorPrompt-text">
            {languageObj.text[0]}
            <br />
            {languageObj.text[1]}
          </div>
          <Link to={"/"}>
            <div className="ErrorPrompt-closeBtn">{languageObj.closeBtn}</div>
          </Link>
        </div>
      </div>
    );
  }
}
ErrorPrompt.propTypes = {
  t: PropTypes.func,
};

export default ErrorPrompt;
